import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone } from 'lucide-react';
import AnimatedPage from '../components/AnimatedPage';

const Purepell = () => {
  return (
    <AnimatedPage className="min-h-screen bg-stone-50">
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-stone-50 via-stone-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-4">
              Bioidentical Hormone Replacement Therapy with Purepell
            </h1>
            <div className="h-1 w-24 bg-gradient-to-r from-amber-500 via-amber-500 to-orange-500 mx-auto mb-6"></div>
            <p className="text-xl text-stone-700 leading-relaxed max-w-4xl mx-auto">
              As a certified hormone specialist, Dr. Williams performs convenient, in-office pelleting procedures.
            </p>
          </div>

          {/* Video Section */}
          <div className="max-w-5xl mx-auto">
            <Card className="glass-card-strong shadow-strong card-premium overflow-hidden">
              <CardContent className="p-0">
                <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
                  <video
                    className="absolute top-0 left-0 w-full h-full object-cover"
                    controls
                    poster=""
                  >
                    <source 
                      src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/zzn83xju_Purepell11.mp4" 
                      type="video/mp4" 
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </CardContent>
            </Card>

            {/* QR Code Content - Underneath Video */}
            <div className="mt-12">
              <div className="flex items-center justify-center gap-8">
                {/* Text on Left */}
                <p className="text-xl text-stone-700 leading-relaxed">
                  Scan the QR code to schedule a consultation
                </p>
                
                {/* QR Code on Right */}
                <div className="flex-shrink-0">
                  <div className="bg-stone-50 p-3 rounded-lg shadow border border-stone-200">
                    <img
                      src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/ioizrgyv_Contact_Us_QR_Code.png"
                      alt="Schedule Consultation QR Code"
                      className="w-32 h-32 object-contain"
                    />
                  </div>
                </div>
              </div>
              
              {/* Cherry Payment Link */}
              <div className="mt-8 text-center">
                <p className="text-base text-stone-700">
                  Use Cherry payment option to make your wellness goals more affordable at{' '}
                  <a 
                    href="https://pay.withcherry.com/crofton-family-practice" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-amber-600 hover:text-amber-700 font-medium underline"
                  >
                    https://pay.withcherry.com/crofton-family-practice
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Purepell Certification Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_premium-med-care/artifacts/auykt3my_Purepell%20Certificate.jpeg"
                alt="Purepell Certification - Karen Smith"
                className="w-56 h-auto rounded-lg shadow-2xl hover:scale-105 transition-transform duration-500 border-2 border-amber-200"
              />
            </div>
          </div>
        </div>
      </section>
    </AnimatedPage>
  );
};

export default Purepell;
